const getUniqueKey = (idx: number): string => {
  return `${idx}`
}

// Enhanced key generation function that uses slug as primary key
const getKeyBySlug = (item: { slug?: string }, idx: number): string => {
  // Use slug as primary key if available and not empty
  if (item.slug && typeof item.slug === 'string' && item.slug.trim() !== '') {
    return `${item.slug}`
  }
  // Fallback to index-based key
  return `${idx}`
}

export { getKeyBySlug }
export default getUniqueKey
